import dayjs from 'dayjs'

const COMPLIANCE_FIELD_NAMES = new Set([
  'compliance_medical_insurance',
  'compliance_patent',
  'compliance_receipt',
])

const normalizeDateValue = (value: unknown): string | null | undefined => {
  if (value === null || value === undefined || value === '') {
    return value === '' ? null : (value as null | undefined)
  }

  const parsed = dayjs(value as string | Date)
  if (!parsed.isValid()) {
    return undefined
  }

  return parsed.toISOString()
}

const isDateField = (fieldName: string, fieldSchema: Record<string, any> | undefined): boolean => {
  const format = fieldSchema?.format
  return format === 'date' || format === 'date-time'
}

export const prepareEmployeeSavePayload = (
  formData: Record<string, any>,
  schema: Record<string, any> | null | undefined,
  permissions: Record<string, string> | undefined,
): Record<string, any> => {
  const properties = schema?.properties || {}
  const payload: Record<string, any> = {}

  Object.keys(formData).forEach(fieldName => {
    if (COMPLIANCE_FIELD_NAMES.has(fieldName)) {
      return
    }

    if (permissions?.[fieldName] === 'view') {
      return
    }

    let value = formData[fieldName]

    if (isDateField(fieldName, properties[fieldName])) {
      value = normalizeDateValue(value)
      if (value === undefined) {
        return
      }
    }

    payload[fieldName] = value
  })

  return payload
}
